import { render, staticRenderFns } from "./vehicleOrders.vue?vue&type=template&id=897f92dc"
import script from "./vehicleOrders.vue?vue&type=script&lang=js"
export * from "./vehicleOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports